<div mat-dialog-title class="title ds">
  <span>{{data.title}}</span>
  @if (!data.disableClose) {
    <button mat-icon-button class="close-dialog-button" mat-dialog-close>
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  }
</div>
<div mat-dialog-content class="content ds">
  <div [ngClass]="{'mandatory-label': mandatory}" [innerHTML]="data.content"></div>
  <div class="input-container" [formGroup]="form">
    <mat-form-field class="input no-subscript note-input no-padding" [ngClass]="{'mandatory': mandatory}">
      <textarea matInput required formControlName="reason"></textarea>
    </mat-form-field>
  </div>
</div>
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    @for (button of data.buttons; track button; let i = $index) {
      <ds-button id="dialogButton_{{i}}" variant="label-only" size="medium"
        [type]="button.style || 'secondary'" (onClick)="btnCallback(i)" [label]="button.label">
      </ds-button>
    }
  </div>
</div>